<template>
    <ConfirmDialog />
    <InfoBoxModal />
    <loading-bar v-if="isLoading" />
    <div class="container ps-0 pe-0 mb-5">
        <router-view >
            
        </router-view>
    </div>
   <FlashMessengerHolder />
   <div class="dummyPlace"></div>
   
   <div class="versionFooter mt-5 text-center">Version {{packageJson.version}}</div>
   <NavFooter v-if="!isLoading" />
</template>

<script>
import FlashMessengerHolder from './components/general/FlashMessengerHolder.vue';
import NavFooter from "./components/structure/NavFooter.vue";
import ConfirmDialog from "./components/general/ConfirmDialog.vue";
import packageJson from "../package.json"
import LoadingBar from './components/general/LoadingBar.vue';
import InfoBoxModal from './components/general/InfoBoxModal.vue';
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            packageJson: packageJson
        }
    },
    created() {
        this.updateData();
    },
    methods: {
        updateData() {
            this.$store.dispatch('system/startLoadingProcess')
        }
    },
    computed: {
        ...mapGetters({
            'isLoading': 'system/getIsLoading'
        })
    },
    components: {
    NavFooter,
    FlashMessengerHolder,
    ConfirmDialog,
    LoadingBar,
    InfoBoxModal
}
}
</script>

<style lang="scss" scoped>
    .dummyPlace {
        height: 100px;
    }

    .versionFooter {
        margin-top: 300px;
        margin-bottom: 100px;
        
} 
</style>